var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"available-tiles"},[_c('h3',[_vm._v("取り扱いタイル一覧")]),_vm._v(" "),_c('ul',{staticClass:"available-tiles-lists"},_vm._l((_vm.tiles),function(tile){return _c('li',{key:tile},[_vm._v(_vm._s(tile))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d2400a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availableTiles.vue
// module id = null
// module chunks = 